import { prop, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";

export class Capability extends Resource {
    public override type = 'capabilities';

    @prop()
    public name!: string;

    @prop()
    public active: boolean = true;    

    @prop()
    @required()
    public serviceNormalHours: number = 0;

    @prop()
    @required()
    public serviceUrgentHours: number = 0;
        
}